import { render, staticRenderFns } from "./DetailInfoSection.vue?vue&type=template&id=67c63565&scoped=true&"
import script from "./DetailInfoSection.vue?vue&type=script&lang=js&"
export * from "./DetailInfoSection.vue?vue&type=script&lang=js&"
import style0 from "./DetailInfoSection.vue?vue&type=style&index=0&id=67c63565&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c63565",
  null
  
)

export default component.exports